<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col sm="12">
                <b-card>
                    <div slot="header">
                        <strong>Open Incident's</strong>
                        <div class="card-header-actions">
                            <router-link to="/incident_master">
                                <b-button variant="info" size="sm" style="color: #fff;"><i class="fa fa-long-arrow-left" aria-hidden="true"></i>
                                    Back To Incident Master</b-button>
                            </router-link>
                        </div>
                    </div>

                    <div>
                        <b-row>
                            <b-col sm="4">
                                <b-form-group label-cols-sm="3" label="Search:">
                                <b-input-group>
                                    <b-form-input v-model="filter" placeholder="Enter Vehicle number / Hub Name" @input="searchdata"></b-form-input>
                                    <b-input-group-append>
                                    <b-button :disabled="!filter" @click="clearFilter">Clear</b-button>
                                    </b-input-group-append>
                                </b-input-group>
                                </b-form-group>
                            </b-col>
                            <b-col sm="4">
                                <b-form-group label-cols-sm="6" label="Select Incident Level:">
                                    <b-form-checkbox-group 
                                    v-model="selectedLevels" 
                                    class="mt-1" 
                                    @input="searchdata">
                                    
                                    <b-form-checkbox 
                                      value="hub" 
                                      switch 
                                      class="custom-checkbox mb-1">
                                      Hub Level
                                    </b-form-checkbox>
                                    
                                    <b-form-checkbox 
                                      value="vehicle" 
                                      switch 
                                      class="custom-checkbox">
                                      Vehicle Level
                                    </b-form-checkbox>
                                  </b-form-checkbox-group>
                                    <!-- Switch Checkbox for Hub Level
                                    <b-form-checkbox 
                                      v-model="selectedLevels" 
                                      value="hub" 
                                      switch 
                                      @input="searchdatalevels($event, 'hub')" 
                                      name="some-checkboxes">
                                      Hub Level
                                    </b-form-checkbox>
                                  
                                    Switch Checkbox for Vehicle Level
                                    <b-form-checkbox 
                                      v-model="selectedLevels" 
                                      value="vehicle" 
                                      switch 
                                      @input="searchdatalevels($event, 'vehicle')" 
                                      name="some-checkboxes">
                                      Vehicle Level
                                    </b-form-checkbox> -->
                                </b-form-group>
                            </b-col>

                            <b-col sm="4">
                                <b-form-group label-cols-sm="4" label="Select Origin:">
                                <ejs-multiselect 
                                    id='multi_select2' 
                                    placeholder="Origin Listing" 
                                    v-model="valueWH" 
                                    :dataSource='optionsWH' 
                                    :showSelectAll='showSelectAll' 
                                    selectAllText="Select All" 
                                    unSelectAllText="Unselect All" 
                                    :fields='fieldWH' 
                                    :allowCustomValue='allowCustomValue' 
                                    enableGroupCheckBox="true" 
                                    mode="CheckBox" 
                                    @change="searchdata"
                                />
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </div>

                    <b-row>
                        <b-col>
                            <div class="text-right">
                               <h6><b>Total Records : <span style="color: red;">{{ totalRows }}</span></b></h6>
                            </div>
                        </b-col>
                    </b-row>

                    <div>
                        <b-table show-empty responsive :fields="fields" :items="openlist" :filter="filter" :busy="isBusy" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :bordered="bordered">
                            <div slot="table-busy" class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong>Loading...</strong>
                              </div>
                              <template slot="ttr" slot-scope="row">
                                <div>
                                    {{ ((row.item.ttr?row.item.ttr.hours:'00' )|| '00').toString().padStart(2, '0') }}:
                                    {{ ((row.item.ttr?row.item.ttr.minutes:'00') || '00').toString().padStart(2, '0') }}                                                                     
                                  </div>
                              </template>
                              <template slot="vehicle_no" slot-scope="row">
                                <div>
                                    {{ row.item.hubvehicle }}
                                </div>
                                </template>
                                <template slot="incident_level" slot-scope="row">
                                <div>
                                    {{ row.item.incidentlevel }}
                                </div>
                                </template>
                                <template slot="incident_type" slot-scope="row">
                                <div>
                                    {{ row.item.incidenttype }}
                                </div>
                            </template>
                              <template slot="show_details" slot-scope="row">
                                <b-button
                                  size="sm"
                                  data-toggle="tooltip"
                                  title="View Open Incident"
                                  @click="viewopenincident(row.item)"
                                  :modalShow= modalShow
                                >View Button</b-button>
                            </template>
                        </b-table>
                    </div>

                    <b-modal title="View Open Incident" v-model="modalShow" size="xl" hide-footer>
                        <template slot="default" slot-scope="{ hide }">
                            <b-row class="p-3">
                                <b-col sm="3">
                                    <span><b>Incident Level : -</b> <span v-if="openincident && openincident.incidentlevel"> {{openincident.incidentlevel}} level</span></span>
                                </b-col>
                                <b-col sm="3">
                                    <span><b>Incident Type : -</b> {{openincident.incidenttype}}</span>
                                </b-col>
                                <b-col sm="4">
                                    <div v-if="!isEditing" class="d-flex">
                                        <p><b>Time to Resolve : </b>{{ formattedTime }}</p> &nbsp;&nbsp;&nbsp;
                                        <b-button @click="isEditing = true" size="sm" style="height: 30px;"><i class="fa fa-pencil" aria-hidden="true"></i>
                                        </b-button>
                                    </div>
                                    <div v-else class="d-flex">
                                        <b-form-group label="Time to Resolve:" :label-cols="6">
                                            <b-form-input
                                            v-model="timeInput"
                                            placeholder="HH:MM"
                                            type="text"
                                            ></b-form-input>
                                        </b-form-group> &nbsp;&nbsp;&nbsp;
                                        <b-button :disabled="isReadOnly" @click="validateAndSave" size="sm" style="height: 30px;"><i class="fa fa-check" aria-hidden="true"></i>
                                        </b-button>&nbsp;&nbsp;&nbsp;
                                        <b-button @click="cancelEdit" size="sm"  variant="outline-danger" style="height: 30px;"><i class="fa fa-times" aria-hidden="true"></i>
                                        </b-button>
                                    </div>
                                </b-col>
                            </b-row>
                            <b-row class="p-3">
                                <b-col>
                                    <div>
                                        <span v-if="openincident.incidentlevel === 'vehicle'"><b>Vehicle No. : -</b> {{openincident.hubvehicle}}</span>
                                        <span v-if="openincident.incidentlevel === 'hub'"><b>Hub Name. : -</b> {{openincident.hubvehicle}}</span>
                                        <br><br>
                                        <span><b>Incident name : -</b> {{openincident.incident_name}}</span>
                                        <br><br>
                                        <span><b>Incident ID : -</b> {{openincident.incident_id}}</span>
                                        <br><br>
                                        <span><b>Incident time : -</b> {{openincident.createddate | ConvertTime12hour()}}</span>
                                        <br><br>
                                        <span><b>Incident status : -</b> {{openincident.report_status}}</span>
                                    </div>
                                    <div class="mt-5">
                                        <h5>Incident images :- </h5>
                                        <div>
                                            <img :src="openincident.report_image" alt="images" width="70%" height="200px">
                                        </div>
                                    </div>
                                </b-col>
                                <b-col>
                                    <div class="text-center">
                                        <h5>LOAD STATUS</h5>
                                    </div>
                                    <b-table show-empty :fields="open_indifields" :items="loaditems" :busy="isBusymodel" responsive>
                                        <div slot="table-busy" class="text-center text-danger my-2">
                                            <b-spinner class="align-middle"></b-spinner>
                                            <strong>Loading...</strong>
                                          </div>
                                    </b-table>

                                    <div>
                                        <h5>Incident Video :- </h5>
                                        <div>
                                            <b-embed  type="video" controls>
                                              <source :src="openincident.report_video">
                                            </b-embed>
                                          </div>

                                    </div>
                                </b-col>
                            </b-row>

                            <hr>
                            <br>
                            <footer class="float-right">
                                <router-link 
  :to="{
    path: '/open_approve_incident/' + openincident.report_id,
    query: { 
      incidentlevel: openincident.incidentlevel // Add more query parameters as needed
    }
  }" 
  v-if="openincident.total_count >= 1 && isReadOnly==false"
>
  <b-button variant="success" size="md" type="submit"  :disabled="isReadOnly">Approve Incident</b-button>&nbsp;
</router-link>


                                <b-button variant="success" v-b-modal.modal-1 v-if="openincident.total_count==0 && isReadOnly==false">
                                    Continue
                                </b-button>&nbsp;

                                <b-button variant="danger" size="md" type="submit"  @click="viwerejectmodel()" :disabled="isReadOnly" 
                                :rejectmodel= rejectmodel >Reject Incident
                                </b-button>&nbsp;

                                <b-button size="md" variant="danger" @click="cancel()"
                                    >cancel</b-button
                                    >
                            </footer>
                        </template>
                        <template slot="modal-footer" slot-scope="{ hide }">
                            <b-button size="sm" style="display:none">
                                  Cancel
                            </b-button>
                        </template>
                    </b-modal>

                    <b-modal id="modal-1" title="Confirmation Box" hide-footer>
                        <p class="my-1">Are you sure you want to Continue?</p>
                        <b-button variant="primary" class="float-right" size="sm" @click="continueapproveVehicle()" :disabled="isReadOnly">OK</b-button>
                    </b-modal>

                      
                    <b-modal v-model="rejectmodel" size="lg" title="Reject Reason" hide-footer>
                        <b-row>
                            <b-col sm="2" class="pr-0">
                              <label><b>Comment</b></label>&nbsp;<span style="color: red;">*</span><b> :</b>
                            </b-col>
                            <b-col sm="9" class="pl-0">
                                <b-form-group>
                                    <b-form-textarea id="textarea" v-model="comment" placeholder="Enter comment" rows="4"></b-form-textarea>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <hr>
                        <br>
                        <footer class="float-right">
                            <b-button variant="success" size="md" type="submit" @click="RejectIncident()">Continue
                            </b-button>&nbsp;
                        </footer>
                    </b-modal>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import auth from "@/utils/auth";
import VueDPlayer from 'vue-dplayer'
import 'vue-dplayer/dist/vue-dplayer.css'
export default {
    data() {
        return {
            filter: null,
            isBusy : false,
            fields: [
                { key: "report_id",  label: "SNO."},
                { key: "vehicle_no",  label: "Vehicle Number/Hub Name"},
                { key: "incident_id",  label: "Incident Code"},
                { key: "incident_level",  label: "Incident Level"},
                { key: "incident_type",  label: "Incident Type"},
                { key: "incident_name",  label: "Incident Name"},
                { key: "total_count",  label: "No Of Loads"},
                { key: "ttr",  label: "Time To Resolve"},
                { key: "report_status",  label: "Status"},
                { key: "show_details",  label: "Action"},
            ],
          
            openlist :[],
            totalRows :0,
            modalShow :false,
            openincident : {}, 
            open_indifields :[ 
                {key : 'total_count', label :'Total Count'},
                {key : 'ofd_count', label :'OFD Count'},
                {key : 'intransit_count', label :'Intransit Count'},
                // {key : 'rto_count', label :'RTO Count'},
                // {key : 'ndr_count', label :'NDR Count'},
            ],
            loaditems: [],
            isBusymodel : false,
            loadtotalRows :0,
            fixed:true,
            approvecount : [],
            rejectmodel : false,
            comment : '',
            bordered:true,
            valueWH:[],
            fieldWH:{ text: 'name', value: 'id' },
            optionsWH:[],

            selectedLevels:null,
            selected_Levels:null,
            customer:{},
            isEditing: false, 
            timeInput: '',
            initialTimeInput: '',  // Store the initial value
            accessBody:[],
            isReadOnly:false,
        }
    },

    components: {
        'd-player': VueDPlayer
    },
    created() {
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        this.accessBody = userInfo.body;
        console.log("--------->>>>>>>>>>",userInfo.body)
        this.ischeckbodyvalidation();
    
        this.showWHlist()
        this.OpenreportList();
       
    },
    computed: {
        formattedTime() {
        const hours = ((this.openincident.ttr?this.openincident.ttr.hours:'00') || '00').toString().padStart(2, '0');
        const minutes = ((this.openincident.ttr?this.openincident.ttr.minutes:'00') || '00').toString().padStart(2, '0');

        return `${hours}:${minutes}`;
        }

    },
    methods: {
        ischeckbodyvalidation(){
            for (let i = 0; i < this.accessBody.length; i++) {
                const element = this.accessBody[i];
            
                if (element.title=='Incident Master' && element.isReadonly==true) {
                  this.isReadOnly=true
                }
            if (element.child) {
                for (let j = 0; j < element.child.length; j++) {
                const k = element.child[j];
                if (k.title=='Incident Master' && k.isReadonly==true) {
                    this.isReadOnly=true
                }
                }
            }
            }
            console.log(" this.isReadOnly", this.isReadOnly)
        },

        validateAndSave() {
            // Check if the input matches the HH:MM format
            // const regex = /^(\d{1,2}):(\d{2})$/;  // Allow 1 or 2 digits for hours and exactly 2 digits for minutes
            const regex = /^(\d+):(\d{2})$/;

            // Extract the parts if it matches
            const timeParts = this.timeInput.match(regex);

            if (timeParts) {
                document.getElementById("overlay").style.display = "block";
                var userdata = localStorage.getItem("userData");
                var userInfo = JSON.parse(userdata);

                const obj = {
                    status : "open",
                    reportid : `${this.openincident.report_id}`,
                    ttr:this.timeInput,
                    lastmodifiedby: `${userInfo.userfirstname}` + " " + `${userInfo.userlastname}`,
                }
                console.log("obj",obj)
                // return false
                this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/editTtrForIncident`,obj)
                .then(result =>{
                    document.getElementById("overlay").style.display = "none";
                    if (result.body.returnmsg === "Successful") {
                        this.$fire({
                            text: 'Time Update Successful',
                            type: "success",
                            timer: 30000
                        });
                        this.modalShow = false;
                        this.OpenreportList();

                    } else {
                        this.$fire({
                            text:result.body.returnvalue,
                            type: "error",
                            timer: 30000
                        });
                    }
                })
                .catch((ex) => {
                    console.log("error", ex);
                });

                this.isEditing = false;
            } else {
                // Show error if the format is wrong (e.g., "time:minutes")
                this.$fire({
                text: 'Invalid format. Please enter a valid time in HH:MM format.',
                type: "error",
                timer: 3000,
                });
            }
        },

        cancelEdit() {
            this.timeInput = this.initialTimeInput;
            this.isEditing = false;
        },
        play() {
            console.log('play callback')
        },

        clearFilter(){
            this.filter=null;
            this.OpenreportList();
        },

        searchdata(selected) {
             if (selected.length) {
                if (selected.includes('hub') && selected.includes('vehicle')) {
                    this.selected_Levels=null;
                } else if (selected.includes('hub')) {
                    this.selected_Levels='hub';
                } else if (selected.includes('vehicle')) {
                    this.selected_Levels='vehicle';
                }
             }
             else{
                this.selected_Levels=null;
             }
            this.OpenreportList();
        },

        OpenreportList : function () {

            this.openlist = [];
            this.totalRows = 0;
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            var filter = []
            if (this.filter) {
            
                filter.push(this.filter)
            }
            this.isBusy = true;
            const obj = {
                incidentlevel: this.selected_Levels,
                hubid:this.valueWH,
                searchparams:filter,
                report_status:"open",
              
            }

            // return false
            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/incidentReportList`,obj)
            .then(result =>{
                this.isBusy = false;
                if (result.body.returnmsg === "Successful") {
                    this.openlist = result.body.returnvalue;
                    this.totalRows = result.body.returnvalue.length;
                } else {
                    this.openlist = [];
                    this.totalRows = 0;
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },

        VehicleloadList : function (report_id) {
            if (this.openincident.incidentlevel)
            this.loaditems = [];
            this.loadtotalRows = 0;

            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            this.isBusymodel = true;
            const obj = {
                report_status:"open",
                vehicle_id : this.openincident.vehicle_id== null ? '0' : this.openincident.vehicle_id,
                report_id : report_id,
                incidentlevel: this.openincident.incidentlevel === 'hub' ? "hub" : "vehicle"
            }
            console.log("obj",obj)
            // return false
            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getVehicleLoadCount`,obj)
            .then(result =>{
                this.isBusymodel = false;
                if (result.body.returnmsg === "Successful") {
                    this.loaditems = result.body.returnvalue;
                    this.loadtotalRows = result.body.returnvalue.length;
                } else {
                    this.loaditems = [];
                    this.loadtotalRows = 0;
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },
        
        showWHlist:function(){
          
            var userdata = localStorage.getItem('userData')
            var userInfo = JSON.parse(userdata)
            
            var csvObj = {
                sysusermasterid:`${userInfo.sysusermasterid}`,
                usertype:`${userInfo.user_type}`
            };
            this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getAllHubListing`, csvObj)
                .then(result => {
                
                if (result.body.returnmsg === 'Successful') {
                    this.optionsWH=[];
                
                    this.WHData  = result.body.returnvalue;
                    
                    for(let j = 0; j < this.WHData.length; j++) {
                        let WH = {
                        name: this.WHData[j].hubname + " - " + this.WHData[j].hubid,
                        id: this.WHData[j].hubid,
                        }
                    this.optionsWH.push(WH);
                    }
                
                } else {              
                    this.WHData  = result.body.returnvalue;
                }
            

            })
            .catch(ex => {
                console.log("error-----", ex);
            });
        },

        viewopenincident :function (value){
            this.modalShow = true;            
            this.openincident = value;
            this.initialTimeInput = `${((this.openincident.ttr?this.openincident.ttr.hours:'00') || '00').toString().padStart(2, '0')}:${((this.openincident.ttr?this.openincident.ttr.minutes:'00') || '00').toString().padStart(2, '0')}`;
            this.timeInput = `${((this.openincident.ttr?this.openincident.ttr.hours:'00') || '00').toString().padStart(2, '0')}:${((this.openincident.ttr?this.openincident.ttr.minutes:'00') || '00').toString().padStart(2, '0')}`;
            this.VehicleloadList(value.report_id);
        },

        cancel : function () {
            this.comment='';
            this.modalShow = false;
            this.rejectmodel = false;
            document.getElementById("overlay").style.display = "none";
        },

        viwerejectmodel : function () {
            this.comment='';
            this.rejectmodel = true;
        },

        RejectIncident : function () {
            document.getElementById("overlay").style.display = "block";
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            if (this.comment !="") {
                const obj = {
                report_status : "Rejected",
                report_id : this.openincident.report_id,
                reject_reason:this.comment,
                lastmodifiedby: `${userInfo.userfirstname}` + " " + `${userInfo.userlastname}`,
            }
            console.log("obj",obj)
            // return false
            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/rejectIncident`,obj)
            .then(result =>{
                document.getElementById("overlay").style.display = "none";
                if (result.body.returnmsg === "Successful") {
                    this.$fire({
                        text: result.body.returnvalue,
                        type: "success",
                        timer: 30000
                    });
                    this.rejectmodel = false;
                    this.$router.push('/rejected_incident')
                } else {
                    this.$fire({
                        text:result.body.returnvalue,
                        type: "error",
                        timer: 30000
                    });
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
            } else {
                this.$fire({
                    text:'Please Enter Comment',
                    type: "error",
                    timer: 30000
                });
                document.getElementById("overlay").style.display = "none";
            }
           
        },

        continueapproveVehicle(){
            document.getElementById("overlay").style.display = "block";
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            const obj = {
                report_status : "Approved",
                report_id : this.openincident.report_id,
                lastmodifiedby : `${userInfo.userfirstname} ${userInfo.userlastname}`,
            }
            console.log("@@@@@@@@@",obj)
            // return false
            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/appproveIncidentWithoutLoad`,obj).then((result)=>{
            document.getElementById("overlay").style.display = "none";
                if (result.body.returnmsg === "Successful") {
                    this.$fire({
                        text: result.body.returnvalue,
                        type: "success",
                        timer: 30000
                    });
                    
                    this.$router.push('/approve_incident')
                } else {
                    this.$fire({
                        text:result.body.returnvalue,
                        type: "error",
                        timer: 30000
                    });
                }
            }).catch((ex) => {
                console.log("error", ex);
            });
            
        },
    },
}
</script>